import React from 'react';

const CustomTextQuestion = props => {
  const questionId = props.customQuestionId;

  const textChangeHandler = event => props.customTextChanged(event.target.value, props.eval.id, questionId);

  const checkboxChangeHandler = event => props.customTextCheckboxChanged(event.target.checked, props.eval.id, questionId);

  const answer = props.customTextAnswers && props.customTextAnswers[questionId] && !props.customTextAnswers[questionId].check ?
    props.customTextAnswers[questionId].text : ``;

  const isCheckBoxChecked = props.customTextAnswers && props.customTextAnswers[questionId] ?
    props.customTextAnswers[questionId].check : false;

  return (
    <div className="col-md-6 col-md-offset-3">
      <textarea type="text" className="q-text-input form-control" rows="5" value={ answer } autoFocus autoComplete="off" onChange={ textChangeHandler } />
      <div className="center">
        <label className="cannotNameAnyone">
          <input type="checkbox" name="nobody" onClick={ checkboxChangeHandler } className="cannotNameAnyoneCheckbox" value={ isCheckBoxChecked } checked={ isCheckBoxChecked } />
          {` ${props.lang.q_dontasnwer}`}
        </label>
      </div>
    </div>
  );
};

export default CustomTextQuestion;
